import React from "react";
import {
  Tooltip as Base,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from "./ui/tooltip";

const hasTooltipValue = (value) => {
  if (value === null || value === undefined || value === false) {
    return false;
  }

  if (typeof value === "string") {
    return value.length > 0;
  }

  if (Array.isArray(value)) {
    return React.Children.count(value) > 0;
  }

  return true;
};

const Tooltip = ({ className, children, value, delayDuration = 300 }) =>
  hasTooltipValue(value) ? (
    <Base delayDuration={delayDuration}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipPortal>
        <TooltipContent className={className}>{value}</TooltipContent>
      </TooltipPortal>
    </Base>
  ) : (
    children
  );

export default Tooltip;
